import shopData from '../data/shop-items.json';
import { VIRTUAL_REWARD_ECONOMY_ENABLED } from '../config/rewards';

interface Props {
  avatarEmoji: string;
  equippedItemIds?: string[];
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_MAP = {
  sm: { avatar: 'text-xl', wrapper: 'w-8 h-8', accessory: 'text-xs -top-1.5 -right-1.5' },
  md: { avatar: 'text-2xl', wrapper: 'w-10 h-10', accessory: 'text-sm -top-2 -right-2' },
  lg: { avatar: 'text-4xl', wrapper: 'w-14 h-14', accessory: 'text-lg -top-2.5 -right-2.5' },
};

const AVATAR_ITEMS = new Map(
  shopData
    .filter(i => i.category === 'avatar')
    .map(i => [i.id, i.emoji])
);

export function AvatarWithAccessories({ avatarEmoji, equippedItemIds, size = 'md' }: Props) {
  const s = SIZE_MAP[size];

  let accessoryEmoji: string | undefined;
  if (VIRTUAL_REWARD_ECONOMY_ENABLED && equippedItemIds) {
    for (const id of equippedItemIds) {
      const emoji = AVATAR_ITEMS.get(id);
      if (emoji) { accessoryEmoji = emoji; break; }
    }
  }

  return (
    <div className={`relative inline-flex items-center justify-center ${s.wrapper}`}>
      <span className={s.avatar}>{avatarEmoji}</span>
      {accessoryEmoji && (
        <span className={`absolute ${s.accessory} drop-shadow-sm`}>
          {accessoryEmoji}
        </span>
      )}
    </div>
  );
}
